/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { MenuItem } from '@mui/material';
import { SelectDropdown } from './SelectDropdown';

export const SelectDepartment = (props) => {
  return (
    <SelectDropdown
      sx={{ minWidth: 250 }}
      size="small"
      label="Department"
      value={props.department}
      onChange={props.handleDepartmantChange}
    >
      <MenuItem value="all">All Departments</MenuItem>
      {props.departmentList.map((data, index) => (
        <MenuItem key={index} value={data.deptname}>
          {data.deptname}
        </MenuItem>
      ))}
    </SelectDropdown>
  );
};
